import {defineComponent} from 'vue';

export default defineComponent({
    name: 'GoogleTagManager',
    created() {
        const configuration = require('../../config/' + process.env.VUE_APP_ENVIRONMENT + '/project.yaml');/* eslint @typescript-eslint/no-var-requires: "off" */
        if (configuration[process.env.VUE_APP_ENVIRONMENT].tracking) {
            this.generate()
        }
    },
    render() {
        return ''
    },
    methods: {
        generate() {
            eval(
                `window.gtmData=[];(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                '//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                })(window,document,'script','dataLayer','GTM-WVWNWXG');`
            )
        }
    }
});